import Popup from "reactjs-popup";
import styled from "styled-components";

export const BodyCard = styled.div<any>`
  text-align: left;
  margin-top: 5px;
  margin-bottom: 1.5em;
  margin-right: 10px;
  text-align: ${(props) => typeof props.center === "undefined" || props.center === "none" ? "left" : "center"};
  & label{
    font-size:14px;
    display: block;
    & > span{
      color: #ff0000;
      font-size:12px;
    }
  }
`

export const StyledPopup = styled(Popup)`
&-content {
    max-width: 610px;
    z-index: 10000 !important;
    padding: 20px;
    & .container{
      width: 100%;
    }
    @media (max-width: ${(props) => props.theme.breakpoints.md}) {
      margin-bottom: 0px;
      margin-top: 20px !important;
      width: 80% !important;
    }
    & > div {
      border-radius: 0px !important;
      & div {
        border-radius: 0px;
      }
    }
  }
`;

export const HeadCard = styled.div<any>`
  display: flex;
  justify-content: ${(props) => typeof props.center === "undefined" || props.center === "none" ? "space-between" : "center"};
  margin-top: .5em;
  margin-bottom: 1.5em;
  & p {
    margin: 0px;
  }
`

export const BottomCard = styled.div<any>`
  display: flex;
  justify-content: ;
  justify-content: ${(props) => typeof props.center === "undefined" || props.center === "none" ? "flex-start" : "center"};
  margin-top: 1em;
  margin-right: 10px;
  & button {
    width: 165px;
    height: 35px;
    font-size:16px;
    &.ml-2{
      margin-left: 1.2rem;
    }
  }
`